<template>
  <div class="card shadow mb-4">
    <div class="card-header py-3">
      <span class="m-0 font-weight-bold text-primary">Customer List</span>
    </div>
    <div class="card-body">
      <b-container fluid>
        <b-row>
          <b-col sm="4" lg="3" md="4">
            <b-form-group
              label="Filter"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              label-for="filterInput"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col
            offset-md="4"
            offset-sm="4"
            offset-lg="6"
            sm="4"
            md="4"
            lg="3"
            class="my-1"
          >
            <b-form-group
              label="Per page"
              label-cols-sm="6"
              label-cols-md="4"
              label-cols-lg="3"
              label-align-sm="right"
              label-size="sm"
              label-for="perPageSelect"
              class="mb-0"
            >
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-table
          show-empty
          small
          stacked="md"
          :busy="loading"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filterIncludedFields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
        <b-row>
          <b-col sm="4" md="4" lg="4" class="my-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { dbFs } from "@/modules/database";
export default {
  data() {
    return {
      fields: [
        {
          key: "sr",
          label: "#",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          class: "text-center"
        },
        {
          key: "number",
          label: "Number",
          sortable: false,
          class: "text-center"
        }
      ],
      items: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      loading: false
    };
  },

  computed: {
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {
    this.setupFirebaseReading();
    this.totalRows = this.items.length;
  },
  methods: {
    setupFirebaseReading() {
      let count = 0;
      this.loading = true;
      dbFs
        .collection("customer")
        .get()
        .then(customerSnapshot => {
          customerSnapshot.forEach(customer => {
            let customerData = customer.data();
            let name = "--";
            let email = "--";
            let number = "--";
            if (customerData.name) {
              name = customerData.name;
            }
            if (customerData.email) {
              email = customerData.email;
            }
            if (customerData.number) {
              number = customerData.number;
            }
            this.items.push({
              sr: ++count,
              name: name,
              email: email,
              number: number
            });
          });
          this.totalRows = this.items.length;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>
